import { useGetProjectsQuery } from "../../../../../api"
import { TProjectsListResponse } from "../../../../../api/types"
import { PageLayout } from "../../../../../components/PageLayout"
import { ProjectsList } from "../../../../../components/ProjectsPage/ProjectsList"

export const UserProjects = () => {
    // TODO: пока-что берутся все проекты, а не личные проекты конкретного пользователя
    const { data: projects } = useGetProjectsQuery()

    const list: TProjectsListResponse = projects ?? []

    return (
        <PageLayout 
            title="Проекты которые пользователь основал"
            mainComponent={<ProjectsList projects={list} />}
        />
    )
}
